import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { deleteMatchSchedule, getMatchSchedule, getMatchScheduleById } from "./actions";

export const matchScheduleEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.matchScheduleId,
});

const initialState = matchScheduleEntityAdapter.getInitialState({
  count: 0,
  isLoading: false,
});

export const matchScheduleSlice = createSlice({
  name: "matchSchedule",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMatchSchedule.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getMatchSchedule.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(getMatchSchedule.fulfilled, (state, action) => {
      matchScheduleEntityAdapter.setAll(state, action.payload.data.matchSchedules);
      state.count = action.payload.data.matchSchedules.length;
      state.isLoading = false;
    });

    builder.addCase(getMatchScheduleById.fulfilled, (state, action) => {
      matchScheduleEntityAdapter.upsertOne(state, action.payload.data);
    });

    builder.addCase(deleteMatchSchedule.fulfilled, (state, action) => {
      if (action?.payload?.status === 204 && state.ids.includes(action?.meta?.arg?.matchScheduleId)) {
        matchScheduleEntityAdapter.removeOne(state, action?.meta?.arg?.matchScheduleId);
        state.count = state.count - 1;
      }
    });
  },
});

export default matchScheduleSlice.reducer;
